import React, { useEffect, useState } from "react";
import "./signUp.css";
import { LoginSignUpLayout } from "../../layouts";
import { SignUpForm } from "./sections";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

function SignUp() {
  const { signup, error, isAuthenticated, loading } = useAuth();

  const [errors, setErrors] = useState({});
  const [pageErrors, setPageErrors] = useState({
    2: { state: false },
    3: { state: false },
  });

  const [formData, setFormData] = useState({
    address: {
      additional: null,
      cep: "",
      city: "",
      number: "",
      state: "",
      street: "",
      country: "BR",
    },
    birthday: "",
    cpf: "",
    email: "",
    first_name: "",
    last_name: "",
    password: "",
    passwordConfirmation: "",
    phone_number: "",
  });

  const navigate = useNavigate();

  const getEmptyFieldsErrors = (form) => {
    let emptyFieldsErrors = {};

    for (let item in form) {
      if (!form[item] && item !== "additional") {
        emptyFieldsErrors = {
          ...emptyFieldsErrors,
          [item]: "Por favor, preencha este campo",
        };
      }
    }

    if (form.password !== form.passwordConfirmation) {
      emptyFieldsErrors = {
        ...emptyFieldsErrors,
        passwordConfirmation: "As senhas não coincidem",
      };
    }

    return emptyFieldsErrors;
  };

  const handleSubmit = async (e) => {
    const { address, ...firstFormData } = formData;

    let personalInfoErrors = getEmptyFieldsErrors(firstFormData);

    if (Object.keys(personalInfoErrors).length > 0) {
      setErrors((prev) => {
        return { ...prev, personalInfoErrors };
      });
    }

    let addressErrors = getEmptyFieldsErrors(address);

    if (Object.keys(addressErrors).length > 0) {
      setErrors((prev) => {
        return { ...prev, addressErrors };
      });
    } else {
      await signup(formData);

      for (let item in errors) {
        if (!errors[item]) {
          delete errors[item];
        }
      }

      if (!Object.keys(errors).length && isAuthenticated()) {
        navigate("/confirmacao-pendente", {
          replace: true,
          state: { email: formData.email },
        });
      }
    }
  };

  useEffect(() => {
    if (error) {
      setFormErrors(formData);
    }
  }, [error?.errors]);

  const setFormErrors = (data) => {
    let { address, ...firstFormData } = data;

    if (error) {
      for (let item in error.errors) {
        setErrors((prev) => {
          return {
            ...prev,
            [item]: error.errors[item][0],
          };
        });
      }
    }
  };

  return (
    <div>
      <LoginSignUpLayout>
        <SignUpForm
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          pageErrors={pageErrors}
          handleSubmit={handleSubmit}
          loading={loading}
        />
      </LoginSignUpLayout>
    </div>
  );
}

export default SignUp;
